import { Button } from '@uhg-abyss/web/ui/Button';

export type SuggestProgramUniteUsProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

export function SuggestProgramUniteUs({
  isOpen,
  setIsOpen,
}: SuggestProgramUniteUsProps): React.JSX.Element {
  function info() {
    const items = [
      'Organization/Program Name',
      'Program Description',
      'Point of Contact Name',
      'Point of Contact Email',
      'Program Phone Number',
      'Program Domain (URL)',
    ];

    return (
      <div>
        {items.map((item, index) => (
          <div key={index}>
            <span style={{ marginRight: '5px' }}>&#x2022;</span>
            {item}
          </div>
        ))}
      </div>
    );
  }

  return (
    <>
      <div data-cy="suggest-program-unite-us">
        <hr
          className="findhelpSuggestProgramSpacing"
          width="100%"
          size="2"
          color="grey"
          noshade
        />
        <span>
          Please contact the Unite Us market specific contact for inclusion of
          this resource in the state specific network.
        </span>
      </div>
      <div>
        <span>Include the following information in your request:</span>
        <div className="benefitsrchspacing findhelpSuggestProgramSpacing">
          {info()}
        </div>
        <span>
          The Unite Us market specific contact will provide you with all updates
          as to the outcome of your request.
        </span>
        <hr
          className="findhelpSuggestProgramSpacing"
          width="100%"
          size="2"
          color="grey"
          noshade
        />
        <div className="uniteUsSuggestProgramCloseButton">
          <Button
            onClick={() => {
              setIsOpen(false);
            }}
          >
            Close
          </Button>
        </div>
      </div>
    </>
  );
}
